import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import type { TBookAlias } from '@shared/jp/product';
import type { IBookPreview } from '@shared/jp/data/products';

@Component({
  selector: 'app-carousel[books]',
  templateUrl: './carousel.component.html',
  styleUrls: ['./carousel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CarouselComponent {
  @Input() books!: IBookPreview[];

  @Output() buttonClick = new EventEmitter<TBookAlias>();

  // constructor() {}

  public onButtonClick(alias: TBookAlias) {
    this.buttonClick.emit(alias);
  }
}
